import Index from './index.vue'

export default {
  name: 'applicationExtensionPage',
  path: '/v-admin/widget-installation',
  component: Index,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.application.extension.title'
  }
}
